import * as React from 'react';

import {Pencil} from 'shells/icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';

import styles from './template-sidebar.module.css';

type Props = {
    isActive: boolean;
    onClick: () => void;
};

export function FromScratchButton(props: Props) {
    return (
        <div
            onClick={props.onClick}
            className={props.isActive ? styles['from-scratch--active'] : styles['from-scratch']}
        >
            <StackLegacy isHorizontal={true} alignCenter={true} spacing={8}>
                <Pencil size={16} />
                Create email from scratch
            </StackLegacy>
        </div>
    );
}
